import React from 'react'
import Modal from 'react-responsive-modal'

class ModalBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {open: this.props.open, alert: this.props.alert}
  }

  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.open === 'boolean') {
      this.setState({open: nextProps.open, alert: nextProps.alert})
    }
  }

  onCloseModal = () => {
    if (this.props.onCloseModal) {
      this.props.onCloseModal() // allows callback
    }
    this.setState({open: false})
  }

  render() {
    return (
      <Modal
        open={this.state.open}
        onClose={this.onCloseModal}
        center
        closeOnOverlayClick={true}
        showCloseIcon={true}
        classNames={(Object.assign({modal: 'modal-alert', closeButton: 'modal-alert-close'}, {...this.props.classNames}))}
      >
        <h4 className="center-align">{this.state.alert.title}</h4>
        <div className="center-align">{this.state.alert.message}</div>
        <div className="modal-action center-align">{this.props.closeBtn || <a href="javascript:;" className="btn btn-unicorn" onClick={this.onCloseModal}>Close</a>}</div>
      </Modal>
    )
  }
}

export default ModalBox



// WEBPACK FOOTER //
// ./assets/js/lib/Modal.jsx